'use client'
import { Dispatch, ReactNode, SetStateAction, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import THREEJSConfig from '@/app/ui/engine-conf/threejs';
import WGPUConfig from '@/app/ui/engine-conf/wgpu';

type AudioConfigConfigProp = {
    setSelectedConf: Dispatch<SetStateAction<number>>
}

const AudioConfig = (props: AudioConfigConfigProp):ReactNode =>{
    
    
    var sfxStorage = localStorage.getItem('sfxVolume');
    var musicStorage = localStorage.getItem('musicVolume');
    var engineStorage = localStorage.getItem('engineVolume');

    
    let sfxVolume = sfxStorage ? parseInt(sfxStorage) : 30;
    let musicVolume = musicStorage ? parseInt(musicStorage) : 30;
    let engineVolume = engineStorage ? parseInt(engineStorage) : 30;
    

    const [sfx, set_sfx ] = useState<number>(sfxVolume)
    const [music, set_music ] = useState<number>(musicVolume)
    const [engine, set_engine ] = useState<number>(engineVolume)

            
    return (
        <div className='container'>
            <div className='text-right'><button onClick={()=> props.setSelectedConf(0)}>x</button></div>
            <label htmlFor='sfx-volume'>sfx</label><input type="text" id='sfx-volume' value={sfx} onChange={(e) => { const val = e.target.value; localStorage.setItem('sfxVolume',val); set_sfx(parseInt(val))}}/>
            <label htmlFor='music-volume'>music</label><input type="text" id='music-volume' value={music} onChange={(e) => { const val = e.target.value; localStorage.setItem('musicVolume',val); set_music(parseInt(val))}}/>
            <label htmlFor='engine-volume'>engine</label><input type="text" id='engine-volume' value={engine} onChange={(e) => { const val = e.target.value; localStorage.setItem('engineVolume',val); set_engine(parseInt(val))}}/>
            
        </div>
    );
}
export default AudioConfig;
        